import { useMemo } from 'react'
import IMask from 'imask'

type Provider = 'Azerfon' | 'Bakcell' | 'Azercell' | 'None'

export function usePhoneFormatter() {
  return useMemo(() => {
    return (rawValue: string): { formatted: string; provider: Provider } => {
      const digits = rawValue.replace(/\D/g, '')
      const lastNine = digits.slice(-9)

      if (lastNine.length < 9) {
        return { formatted: '', provider: 'None' }
      }

      const masked = IMask.createMask({
        mask: '(00) 000-00-00',
      })

      masked.resolve(lastNine)
      const formatted = masked.value

      const prefix = lastNine.slice(0, 2)

      let provider: Provider = 'None'
      if (['70', '77'].includes(prefix)) provider = 'Azerfon'
      else if (['55', '99'].includes(prefix)) provider = 'Bakcell'
      else if (['50', '51', '10'].includes(prefix)) provider = 'Azercell'

      return { formatted, provider }
    }
  }, [])
}
